exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InspectedElementTree___2_4hD {\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n.InspectedElementTree___2_4hD:first-of-type {\n  border-top: none;\n}\n\n.HeaderRow___3I5kU {\n  display: flex;\n  align-items: center;\n}\n\n.Header___2LZLy {\n  display: flex;\n  align-items: center;\n  flex: 1 1;\n  font-family: var(--font-family-sans);\n}\n\n.Item___3t7sh {\n  display: flex;\n}\n\n.Name___6619F {\n  color: var(--color-attribute-name);\n  flex: 0 0 auto;\n}\n.Name___6619F:after {\n  content: ': ';\n  color: var(--color-text);\n  margin-right: 0.5rem;\n}\n\n.Value___na2y1 {\n  color: var(--color-attribute-value);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.None___1ezJC {\n  color: var(--color-dimmer);\n  font-style: italic;\n}\n\n.Empty___2hAqe {\n  color: var(--color-dimmer);\n  font-style: italic;\n  padding-left: 0.75rem;\n}\n\n.ToggleSuspenseRow___3Abo4 {\n  padding-left: 1rem;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.EditableValue___2B5lx {\n  min-width: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"InspectedElementTree": "InspectedElementTree___2_4hD",
	"HeaderRow": "HeaderRow___3I5kU",
	"Header": "Header___2LZLy",
	"Item": "Item___3t7sh",
	"Name": "Name___6619F",
	"Value": "Value___na2y1",
	"None": "None___1ezJC",
	"Empty": "Empty___2hAqe",
	"ToggleSuspenseRow": "ToggleSuspenseRow___3Abo4",
	"EditableValue": "EditableValue___2B5lx"
};